import * as React from 'react'

import {
    Stack,
    Box,
    Button
} from '@mui/material'
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom'

import {HashLink as Link } from "react-router-hash-link";

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';


import { HeaderComponent, HeaderContent, IconsDiv, Logo, LogoDiv, MobileDiv, NavItem,  NavMenu, SearchDiv } from './styles';

import LogoIcon from '../../assets/images/logo/logoSetra.png'
import { Information } from './Information';
import { Navigation } from './Navigation';

interface TopHeaderProps {
    reference?: any;
    title?: any;
}

const Header: React.FC<TopHeaderProps> = ({ reference, title }) => {

    const matches = useMediaQuery('(max-width:1100px)');

    return (
        <HeaderComponent>
            <Information />
            <Navigation />
        </HeaderComponent>
    );
}

export { Header }